import React, { useEffect } from 'react'
import { ENV_URL } from '../../app/constants'

/**
 * @return {null}
 */
export default function BusinessTypesFetch(props) {
    const { setBusinessTypes } = (props = props)

    const fetchData = async () => {
        let url = `${ENV_URL}/api/V1/business/type/index`
        const api = await fetch(url)
        if (api.status == 200) {
            const dataApi = await api.json()
            // Separamos la opción con id 7 (Otros) y las demás opciones
            const otherOption = dataApi.find(bt => bt.id === 7)
            const filteredBusinessTypes = dataApi.filter(bt => bt.id !== 7)

            // Añadimos la opción "Otros" al final
            if (otherOption) {
                filteredBusinessTypes.push(otherOption)
            }

            // Actualizamos el estado con el array modificado
            setBusinessTypes(filteredBusinessTypes)
            return true
        } else {
            return false
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    return null
}
